import { useCallback } from 'react';
import { useAtomCallback } from 'jotai/utils';
import { prevStepStoredInTempFamily, prevStepKeysAtom } from '~/atoms/atoms';

export const useResetAllPrevStepStoredInTemp = () => {
  return useAtomCallback(
    useCallback((get, set) => {
      const keys = get(prevStepKeysAtom);
      keys.forEach((key: string) => {
        // Reset each individual atom to its default value (false in this case)
        set(prevStepStoredInTempFamily(key), undefined);
      });
      // Optionally, clear the keys list after resetting.
      set(prevStepKeysAtom, []);
    }, []),
  );
};
